import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  type: undefined, // required, enum(hdld, phieu_dieu_tour) - Loại văn bản, hợp đồng
  cong_ty_lu_hanh_id: undefined, // optional, ref: cong_ty_lu_hanh - Mã công ty lữ hành
  huong_dan_vien_id: undefined, // optional, ref: huong_dan_vien - Mã hướng dẫn viên
  name: undefined, // required - Tên văn bản, hợp đồng
  status: undefined, // required, enum(draft, signing, signed, cancelled, rejected) - Trạng thái văn bản, hợp đồng. draft - mới tạo; signing - Công ty lữ hành đã ký, Hdv chưa ký; signed - 2 bên đã ký; cancelled - công ty lữ hành hủy; rejected - Hướng dẫn viên hủy
  code: undefined, // required - Số văn bản, hợp đồng
  // optional - Thông tin Sidoc trả về
  sidoc: {
    document_id: undefined, // optional - Mã tài liệu bên Sidoc
    raw: undefined, // optional - Dữ liệu thô Sidoc trả về
  },
  url: undefined, // required - Đường dẫn để xem, ký văn bản, hợp đồng
  history: [
    // optional - Danh sách các lịch sử cập nhật
    {
      type: undefined, // optional - Mã loại lịch sử. Với type là 'hdld' hoặc 'phieu_dieu_tour' thì history.type có các giá trị: 'create' - mới tạo, 'submit_for_signing' - trình ký, 'touragent_signed' - công ty lữ hành ký, 'tourguide_signed' - hướng dẫn viên ký, 'touragent_cancelled' - công ty lữ hành hủy, 'tourguide_rejected' - hướng dẫn viên từ chối
      time: undefined, // required - Thời điểm cập nhật
      content: undefined, // optional - Nội dung ghi chú cập nhật
    },
  ],
};

// validation form
model.validForm = {
  tour_id: [ValidService.requiredChange], //IdRef, required // Mã tour
  huong_dan_vien_cho_xac_nhan_ids: [ValidService.required], //array of IdRef, optional // Danh sách mã hướng dẫn viên
  thoi_gian_bat_dau: [ValidService.requiredChange], //datetime, optional // Thời gian bắt đầu
  thoi_gian_ket_thuc: [ValidService.requiredChange], //datetime, optional // Thời gian kết thúc
  file_dinh_kem_ids: [], //array of IdRef, optional // Danh sách mã các file đính kèm
};

// dữ liệu mẫu các form khác
model.typeVanBan = [
  { value: "hdld", label: "Hợp đồng lao động" },
  { value: "phieu_dieu_tour", label: "Phiếu điều tour" },
];

// validation các form khác
model.validFormOther = {};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100, 500],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "",
  defaultSort: ["thoi_gian_bat_dau", "descending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      code: "",
      type: "",
      huong_dan_vien_id: "",
      thoi_gian_bat_dau: "",
      thoi_gian_ket_thuc: "",
    },
    valid: {
      code: "",
      huong_dan_vien_id: [],
      thoi_gian_bat_dau: [],
      thoi_gian_ket_thuc: [],
    },
    operator: {
      // tour_id: "",
      // huong_dan_vien_ids: "",
      type: "",
      code: ":regex_i:",
      thoi_gian_bat_dau: ":in_that_day:",
      thoi_gian_ket_thuc: ":in_that_day:",
    },
  },
};

export default model;
